/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { Root } from 'hast';
import { pick } from 'lodash';
import { SKIP, visit } from 'unist-util-visit';

export function rehypePluginCleanTree(): ( tree: Root ) => void {
	return ( tree: Root ) => {
		visit( tree, 'element', ( node, index, parent ) => {
			if ( node.properties.dataSkipInSnippets ) {
				parent?.children.splice( index!, 1 );

				return [ SKIP, index ];
			}

			if ( node.properties.dataSkipChildrenInSnippets ) {
				node.children = [];
			}

			node.properties = pick( node.properties, [ 'className', 'ref', 'id' ] );
		} );
	};
}
